import DateService from '@/helpers/DateService';
export default {
    install(Vue) {
        Object.defineProperty(Vue.prototype, '$date', {
            get() { return DateService; }
        });
    }
};
